import { Component, Input } from '@angular/core';


@Component({
    selector: 'files',
    templateUrl: './files.component.html',
    styleUrls: ['./files.component.scss']
})
export class FilesComponent {

    @Input() info : any;

    constructor( 
    ){
    }

}